import { ConditionalRedirect } from '../../type';
import { evaluateConditions } from './evaluateConditions';

interface Args {
  conditionalRedirects?: ConditionalRedirect[];
  formattedValues: Record<string, string>;
  defaultRedirect?: string;
}

/** First entry whose conditions all match wins, the default redirect closes it. */
export const pickRedirect = ({
  conditionalRedirects,
  formattedValues,
  defaultRedirect,
}: Args): string | undefined => {
  if (conditionalRedirects) {
    for (const entry of conditionalRedirects) {
      if (evaluateConditions(entry.conditions, formattedValues)) {
        return entry.redirectUrl;
      }
    }
  }
  return defaultRedirect;
};
